/** @format */

import axios from 'axios';
import { ListedLeadLog, ListedLeadsLogFilterInput, ListedLeadsLogTotalCost } from '../types/listedLeadsLog.types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get listed lead logs with optional filtering
 * Supports filtering by listId, officeId, startDate, and endDate
 */
export const getListedLeadsLogs = async (filter?: ListedLeadsLogFilterInput): Promise<ListedLeadLog[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Fetching listed lead logs with filter:', filter);
  const response = await axios.get(`${apiUrl}/api/leads/logs/listed-lead-logs`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  console.log('Listed lead logs fetched:', response.data);
  return response.data;
};

/**
 * Get listed lead log by ID
 */
export const getListedLeadLogById = async (id: string): Promise<ListedLeadLog> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/leads/logs/listed-lead-logs/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Get total cost of listed lead logs with optional filtering
 */
export const getListedLeadsLogTotalCost = async (filter?: ListedLeadsLogFilterInput): Promise<ListedLeadsLogTotalCost> => {
  const token = localStorage.getItem('accessToken');
  console.log('Fetching total cost with filter:', filter);
  const response = await axios.get(`${apiUrl}/api/leads/logs/cost`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  console.log('Total cost fetched:', response.data);
  return response.data;
};
